import { Injectable, NgZone } from '@angular/core';
import { MapsLoaderService } from './maps-loader.service';
import { RouterService } from '@core/state/router/router.service';
import { WindowRef } from '@vendor/window/window.component';
import { LOGOUT } from '@core/router/app-states';
import { $log } from '@core/utils/logger';

@Injectable()
export class AutocompleteService {

    private autocompleteServiceRef: any;
    private STORAGE_KEY: string = 'pay-app.reloaded';
    private isReloading: boolean = false;

    constructor(private mapsLoader: MapsLoaderService,
                private appRouterService: RouterService,
                private windowRef: WindowRef,
                private ngZone: NgZone) {
    }

    getPlacePredictions(searchTerm: string, options: any = {}): Promise<any> {

        if (searchTerm && searchTerm.length) {
            options.input = searchTerm;

            return new Promise<any>((resolve, reject) => {
                this.ngZone.run(() => {

                    this.mapsLoader.onLoad().then(() => {

                        const w = this.windowRef.nativeWindow;


                        if (w.google && w.google.hasOwnProperty('maps')) {
                            if (!this.autocompleteServiceRef) {
                                this.autocompleteServiceRef = new w.google.maps.places.AutocompleteService();
                            }

                            this.autocompleteServiceRef.getPlacePredictions(options, (predictions, status) => {

                                if (status === w.google.maps.places.PlacesServiceStatus.OK || status === w.google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
                                    
                                    resolve(predictions);
                                } else {
                                    $log.error('getPlacePredictions failed:', status);
                                    if (status === w.google.maps.places.PlacesServiceStatus.UNKNOWN_ERROR) {

                                        // the UNKNOWN_ERROR occurs when someone is idle for more than 48 hours and google api starts to throw 403
                                        // to deal with that.. the first attempt is to reload the browser. and store a key in session storage to account for the fact that
                                        // the reload was done. If same error occurs after resfresh, we check session storage and log them out.
                                        if (!this.isReloading) {
                                            const storageValue: string = w.sessionStorage.getItem(this.STORAGE_KEY);
                                            if (storageValue) {

                                                // if already reloaded, we are not able to continue.. so logout
                                                this.appRouterService.go(LOGOUT);
                                            } else {

                                                // add the key
                                                w.sessionStorage.setItem(this.STORAGE_KEY, '1');
                                                this.isReloading = true;
                                                w.location.reload(true);
                                            }
                                        }
                                    }

                                    reject();
                                }
                            });
                        } else {
                            $log.error('Maps API missing.');
                            reject();
                        }
                    }, (error) => {
                        $log.error('Maps API failed:', error);
                        reject();
                    });
                });
            });
        } else {

            // No search terms so resolve immediately.
            return Promise.resolve([]);
        }
    }

    /**
     * Only used to clear the session storage once the google autocomplete component is destroyed
     * Because we want ensure the next time someone visits the page and again remain idle, we want the session storage
     * to kick in again and help reload the page.
     */
    clearStorage() {
        const w = this.windowRef.nativeWindow;
        w.sessionStorage.removeItem(this.STORAGE_KEY);
        // also reset
        this.isReloading = false;
    }
}
